import { LABELS } from './SupportDetailsTab.constants';

/**
 * Gets comment for a specific user
 * @param {Object} user - User object
 * @param {Array} comments - Array of comments
 * @returns {Object|null} - Comment object or null
 */
export const getCommentForUser = (user, comments) => {
    if (!user || !comments) return null;
    return comments.find(c => c.user && c.user.id === user.id) || null;
};

/**
 * Formats a date to locale string
 * @param {string|Date} date - Date to format
 * @returns {string} - Formatted date or empty string
 */
export const formatCommentDate = (date) => {
    return date ? new Date(date).toLocaleString() : "";
};

/**
 * Gets support status configuration
 * @param {boolean} isProvided - Whether support is provided
 * @returns {Object} - Status configuration
 */
export const getSupportStatusConfig = (isProvided) => {
    return {
        label: isProvided ? LABELS.SUPPORT_PROVIDED : LABELS.WAITING_FOR_SUPPORT,
        color: isProvided ? 'success' : 'warning',
        icon: isProvided ? 'DoneAllIcon' : 'HourglassEmptyIcon'
    };
};

/**
 * Gets approval status configuration
 * @param {boolean} isApproved - Whether approved
 * @returns {Object} - Approval configuration
 */
export const getApprovalStatusConfig = (isApproved) => {
    return {
        label: isApproved ? LABELS.APPROVED : LABELS.NOT_APPROVED,
        color: isApproved ? 'success' : 'error',
        icon: isApproved ? 'CheckCircleIcon' : 'WarningIcon'
    };
};

/**
 * Constructs popup title for a department member
 * @param {Object} member - Member object
 * @param {string} department - Department name
 * @returns {string} - Popup title
 */
export const getPopupTitle = (member, department) => {
    const name = member?.name || member?.username || 'Unknown';
    return `${name} - ${department} Comment`;
};